import styled from 'vue3-styled-components';

export const ModalContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: white;
  overflow: hidden;
`;

// 모달 헤더
export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 1px solid #f3f4f6;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  flex-shrink: 0;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const HeaderIcon = styled.div`
  width: 3rem;
  height: 3rem;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  padding-top: 3px;
`;

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  margin: 0;
`;

export const ClaimInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ClaimInfoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-bottom: 1px solid #e2e8f0;
`;

export const ClaimInfoTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
`;

export const ClaimInfoMain = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  min-height: 0;
`;

export const LeftSection = styled.div`
  flex: 0.4; /* 너비 감소 */
  padding: 20px;
  border-right: 1px solid #e2e8f0;
  overflow-y: auto;
  background: #f8fafc;

      &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f5f9;
        border-radius: 10px;
        margin: 4px 0;
    }

    &::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #cbd5e1, #94a3b8);
        border-radius: 10px;
        border: 2px solid #f1f5f9;
        transition: all 0.2s ease;
        
        &:hover {
        background: linear-gradient(135deg, #94a3b8, #64748b);
        transform: scale(1.05);
        }
        
        &:active {
        background: linear-gradient(135deg, #64748b, #475569);
        }
    }

    &::-webkit-scrollbar-corner {
        background: #f1f5f9;
    }
`;

export const RightSection = styled.div`
  flex: 0.6; /* 너비 증가 */
  padding: 20px;
  overflow-y: auto;

      &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f5f9;
        border-radius: 10px;
        margin: 4px 0;
    }

    &::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #cbd5e1, #94a3b8);
        border-radius: 10px;
        border: 2px solid #f1f5f9;
        transition: all 0.2s ease;
        
        &:hover {
        background: linear-gradient(135deg, #94a3b8, #64748b);
        transform: scale(1.05);
        }
        
        &:active {
        background: linear-gradient(135deg, #64748b, #475569);
        }
    }

    &::-webkit-scrollbar-corner {
        background: #f1f5f9;
    }
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const DataSectionTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  padding-bottom: 12px;
  border-bottom: 2px solid #3b82f6;
`;

export const DeleteAllButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #dc2626;
  }
`;

// 청구 이력 관련 스타일
export const ClaimHistoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
`;

export const ClaimHistoryItem = styled.div`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #3b82f6;
    box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
  }

  &.active {
    border-color: #3b82f6;
    background: #f0f9ff;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);
  }
`;

export const ClaimHistoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const ClaimHistoryTitle = styled.h4`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
`;

// 청구 이력 상태 스타일
export const ClaimHistoryStatus = styled.span`
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    min-width: 80px;
    
    ${props => {
    switch (props.status) {
      case 'info':
        return `
                    background-color: #e3f2fd;
                    color: #1976d2;
                    border: 1px solid #bbdefb;
                `;
      case 'warning':
        return `
                    background-color: #fff3e0;
                    color: #f57c00;
                    border: 1px solid #ffcc02;
                `;
      case 'success':
        return `
                    background-color: #e8f5e8;
                    color: #2e7d32;
                    border: 1px solid #a5d6a7;
                `;
      case 'error':
        return `
                    background-color: #ffebee;
                    color: #c62828;
                    border: 1px solid #ef9a9a;
                `;
      default:
        return `
                    background-color: #f5f5f5;
                    color: #757575;
                    border: 1px solid #e0e0e0;
                `;
    }
  }}
`;

export const ClaimHistoryContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
`;

export const ClaimHistoryInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ClaimHistoryLabel = styled.span`
  font-size: 13px;
  color: #6b7280;
`;

export const ClaimHistoryValue = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #374151;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &.edit {
    background: #f3f4f6;
    color: #374151;
    
    &:hover {
      background: #e5e7eb;
    }
  }

  &.delete {
    background: #fef2f2;
    color: #dc2626;
    border-color: #fecaca;
    
    &:hover {
      background: #fee2e2;
    }
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
`;

export const EmptyStateIcon = styled.div`
  color: #9ca3af;
  margin-bottom: 16px;
`;

export const EmptyStateTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
`;

export const EmptyStateDescription = styled.p`
  margin: 0;
  font-size: 14px;
  color: #6b7280;
`;

export const OcrStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f0fdf4;
  border: 1px solid #10b981;
  border-radius: 6px;
  color: #059669;
  font-size: 14px;
  font-weight: 500;
`;

export const OcrStatusIcon = styled.div`
  display: flex;
  align-items: center;
`;

export const OcrStatusText = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

// 처방전 업로드 관련 스타일
export const PrescriptionUploadContainer = styled.div`
  margin-bottom: 24px;
`;

export const PrescriptionDropZone = styled.div`
  border: 2px dashed #d1d5db;
  border-radius: 12px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  background: #fafafa;
  min-height: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: #3b82f6;
    background: #f8fafc;
  }

  &.active {
    border-color: #10b981;
    background: #f0fdf4;
  }

  &.has-file {
    border-style: solid;
    border-color: #10b981;
    background: #f0fdf4;
  }
`;

export const PrescriptionUploadArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const PrescriptionUploadIcon = styled.div`
  color: #9ca3af;
`;

export const PrescriptionUploadText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PrescriptionUploadMainText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #374151;
`;

export const PrescriptionUploadSubText = styled.div`
  font-size: 13px;
  color: #6b7280;
`;

export const PrescriptionFilePreview = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  width: 100%;
  max-width: 400px;
`;

export const PrescriptionFileIcon = styled.div`
  color: #3b82f6;
`;

export const PrescriptionFileInfo = styled.div`
  flex: 1;
  text-align: left;
`;

export const PrescriptionFileName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 2px;
`;

export const PrescriptionFileSize = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

export const PrescriptionFileRemove = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: #ef4444;
  color: white;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #dc2626;
  }
`;

// 처방전 폼 관련 스타일
export const PrescriptionForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  overflow: hidden;
`;

export const FormLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PrescriptionInput = styled.input`
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 13px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  }
`;

export const PrescriptionSelect = styled.select`
  padding: 6px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 13px;
  background: white;
  transition: all 0.2s ease;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  }
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
`;

export const FormSectionTitle = styled.h4`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
`;

export const CheckboxFormGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  overflow: hidden;
`;

export const PrescriptionCheckbox = styled.input`
  width: 14px;
  height: 14px;
  accent-color: #3b82f6;
  flex-shrink: 0;
`;

export const CheckboxLabel = styled.label`
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  overflow: hidden;
  flex: 1;
  min-width: 0;
`;

export const ClaimInfoFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 15px 24px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
`;

export const CancelButton = styled.button`
  padding: 10px 20px;
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #e5e7eb;
  }
`;

export const SaveButton = styled.button`
  padding: 10px 20px;
  color: white;
  background: linear-gradient(to right, #3b82f6, #9333ea);
  border: none;
  border-radius: 0.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;

  &:hover:not(:disabled) {
    background: linear-gradient(to right, #2563eb, #7c3aed);
  }

  &:focus {
    outline: none;
    ring: 2px;
    ring-color: #3b82f6;
    ring-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const OcrAnalyzeButton = styled.button`
display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    background: linear-gradient(135deg, #5855eb 0%, #7c3aed 100%);
  }

  &:active {
    transform: translateY(0);
  }
`;

// 미리보기 섹션 스타일 추가
export const PreviewSection = styled.div`
  flex: 0.6;
  padding: 20px;
  border-left: 1px solid #e2e8f0;
  overflow: hidden; // 스크롤 숨김
  background: #f8fafc;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px; // 가로 스크롤바 높이 추가
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
    margin: 4px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #cbd5e1, #94a3b8);
    border-radius: 10px;
    border: 2px solid #f1f5f9;
    transition: all 0.2s ease;
    
    &:hover {
      background: linear-gradient(135deg, #94a3b8, #64748b);
      transform: scale(1.05);
    }
    
    &:active {
      background: linear-gradient(135deg, #64748b, #475569);
    }
  }

  &::-webkit-scrollbar-corner {
    background: #f1f5f9;
  }
`;

export const PreviewControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ZoomButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #2563eb;
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
  }
`;

export const ZoomLevel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  min-width: 50px;
  text-align: center;
`;

export const ResetZoomButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #4b5563;
  }
`;

// 로딩 및 에러 상태 스타일 추가
export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #6b7280;
`;

export const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #f3f4f6;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #ef4444;
  font-size: 14px;
`;

// 미리보기 컨테이너 스타일 수정
export const PreviewContainer = styled.div`
  width: 100%;
  height: 600px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  display: block; // flex에서 block으로 변경
  position: relative;
  overflow: auto; // 가로/세로 스크롤 모두 가능하게 함

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #cbd5e1, #94a3b8);
    border-radius: 10px;
    border: 2px solid #f1f5f9;
    transition: all 0.2s ease;
    
    &:hover {
      background: linear-gradient(135deg, #94a3b8, #64748b);
    }
  }

  &::-webkit-scrollbar-corner {
    background: #f1f5f9;
  }
`;

// 미리보기 이미지 스타일 수정
export const PreviewImage = styled.img`
  max-width: none;
  max-height: none;
  width: auto;
  height: auto;
  object-fit: contain;
  cursor: grab;
  display: block;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  &:active {
    cursor: grabbing;
  }
`;

export const DocumentIssueContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

export const DocumentStatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IssueButton = styled.button`
  padding: 6px 12px;
  color: white;
  background: linear-gradient(to right, #3b82f6, #9333ea);
  border: none;
  border-radius: 5px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;

  &:hover:not(:disabled) {
    background: linear-gradient(to right, #2563eb, #7c3aed);
  }

  &:focus {
    outline: none;
    ring: 2px;
    ring-color: #3b82f6;
    ring-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Divider = styled.span`
  color: #9ca3af;
  margin: 0 4px;
`;